export class DslParser {
    constructor(stmtHandlers) {
        Object.defineProperty(this, "stmtHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: stmtHandlers
        });
    }
    parse(input) {
        const statements = [];
        const errors = [];
        const lines = input.split(/\r?\n/);
        let i = 0;
        for (const line of lines) {
            const lineInfo = { line, lineNumber: i++ };
            let stmt = null;
            for (const handler of this.stmtHandlers) {
                if (stmt) {
                    break;
                }
                stmt = handler.parse(line);
            }
            if (stmt) {
                statements.push({ ...stmt, ...lineInfo });
            }
            else if (line.endsWith(';')) {
                errors.push({ ...lineInfo, error: 'Unrecognized statement' });
            }
        }
        return { statements, errors };
    }
}
//# sourceMappingURL=DslParser.js.map